<div class="product-creation-container">
  <!-- Sidebar Navigation -->
  <div class="product-creation-sidebar">
    <app-product-creation-sidebar
      [steps]="productCreationSteps"
      [currentStep]="currentStep"
      [lastFinishedStepId]="product ? product.lastFinishStage : 'basic-details'"
      [product]="product"
    ></app-product-creation-sidebar>
  </div>

  <!-- Step content -->
  <div class="product-creation-content">
    <ng-container content>
      <ng-container *ngIf="!isLoadingProduct.value">
        <div class="content-form-area">
          <div *ngIf="showStepNotAvailable" class="step-not-available">
            <div class="warning-box">
              <i class="fa fa-exclamation-triangle"></i>
              <h3>Step not available yet</h3>
              <p>
                Please complete the previous steps before accessing this
                section.
              </p>
              <button class="btn btn-primary" (click)="goToLastAllowedStep()">
                Take me to last step
              </button>
            </div>
          </div>
          <router-outlet
            *ngIf="!showStepNotAvailable"
            (activate)="onOutletActivate($event)"
          >
          </router-outlet>
        </div>
      </ng-container>
      <ng-container *ngIf="isLoadingProduct.value">
        <div class="loading-overlay">
          <app-common-spinner
            name="product-detail-loading"
          ></app-common-spinner>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
